import { render, staticRenderFns } from "./ScreenLoader.vue?vue&type=template&id=64a2d35e&scoped=true&"
import script from "./ScreenLoader.vue?vue&type=script&lang=ts&"
export * from "./ScreenLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenLoader.vue?vue&type=style&index=0&id=64a2d35e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2d35e",
  null
  
)

export default component.exports